var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49, _tspan50, _tspan51, _tspan52, _tspan53, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _tspan59, _tspan60, _tspan61, _tspan62, _tspan63, _tspan64, _tspan65, _tspan66, _tspan67, _tspan68, _tspan69, _tspan70, _tspan71, _tspan72, _tspan73, _tspan74, _tspan75, _tspan76, _tspan77, _tspan78, _tspan79, _tspan80, _tspan81, _tspan82, _tspan83, _tspan84, _tspan85, _tspan86, _tspan87, _tspan88, _tspan89, _tspan90, _tspan91, _tspan92, _tspan93, _tspan94, _tspan95, _tspan96, _tspan97, _tspan98, _tspan99, _tspan100, _tspan101, _tspan102, _tspan103, _tspan104, _tspan105, _tspan106, _tspan107, _tspan108, _tspan109, _tspan110, _tspan111, _tspan112, _tspan113, _tspan114, _tspan115, _tspan116, _tspan117, _tspan118, _tspan119, _tspan120, _tspan121, _tspan122, _tspan123, _tspan124, _tspan125, _tspan126, _tspan127, _tspan128, _tspan129, _tspan130, _tspan131, _tspan132, _tspan133, _tspan134, _tspan135, _tspan136, _tspan137, _tspan138, _tspan139, _tspan140, _tspan141, _tspan142, _tspan143, _tspan144, _tspan145, _tspan146, _tspan147, _tspan148, _tspan149, _tspan150, _tspan151, _tspan152, _tspan153, _tspan154, _tspan155, _tspan156, _tspan157, _tspan158, _tspan159, _tspan160, _tspan161, _tspan162, _tspan163, _tspan164, _tspan165, _tspan166, _tspan167, _tspan168, _tspan169, _tspan170, _tspan171, _tspan172, _tspan173, _tspan174, _tspan175, _tspan176, _tspan177, _tspan178, _tspan179, _tspan180, _tspan181, _tspan182, _tspan183, _tspan184, _tspan185, _tspan186, _tspan187, _tspan188, _tspan189, _tspan190, _tspan191, _tspan192, _tspan193, _tspan194, _tspan195, _tspan196, _tspan197, _tspan198, _tspan199, _tspan200, _tspan201, _tspan202, _tspan203, _tspan204, _tspan205, _tspan206, _tspan207, _tspan208, _tspan209, _tspan210, _tspan211, _tspan212, _tspan213, _tspan214, _tspan215, _tspan216, _tspan217, _tspan218, _tspan219, _tspan220, _tspan221, _tspan222, _tspan223, _tspan224, _tspan225, _tspan226, _tspan227, _tspan228, _tspan229, _tspan230, _tspan231, _tspan232, _tspan233, _tspan234, _tspan235, _tspan236, _tspan237, _tspan238, _tspan239, _tspan240, _tspan241, _tspan242, _tspan243, _tspan244, _tspan245, _tspan246, _tspan247, _tspan248, _tspan249, _tspan250, _tspan251, _tspan252, _tspan253, _tspan254, _tspan255, _tspan256, _tspan257, _tspan258, _tspan259, _tspan260, _tspan261, _tspan262, _tspan263, _tspan264, _tspan265, _tspan266, _tspan267, _tspan268, _tspan269, _tspan270, _tspan271, _tspan272, _tspan273, _tspan274, _tspan275, _tspan276, _tspan277, _tspan278, _tspan279, _tspan280, _tspan281, _tspan282, _tspan283, _tspan284, _tspan285, _tspan286, _tspan287, _tspan288, _tspan289, _tspan290, _tspan291, _tspan292, _tspan293, _tspan294, _tspan295, _tspan296, _tspan297, _tspan298, _tspan299, _tspan300, _tspan301, _tspan302, _tspan303, _tspan304, _tspan305, _tspan306, _tspan307, _tspan308, _tspan309, _tspan310, _tspan311, _tspan312, _tspan313, _tspan314, _tspan315, _tspan316, _tspan317, _tspan318, _tspan319, _tspan320, _tspan321, _tspan322, _tspan323, _tspan324, _tspan325, _tspan326, _tspan327, _tspan328, _tspan329, _tspan330, _tspan331, _tspan332, _tspan333, _tspan334, _tspan335, _tspan336, _tspan337, _tspan338, _tspan339, _tspan340, _tspan341, _tspan342, _tspan343, _tspan344, _tspan345, _tspan346, _tspan347, _tspan348, _tspan349, _tspan350, _tspan351, _tspan352, _tspan353, _tspan354, _tspan355, _tspan356, _tspan357, _tspan358, _tspan359, _tspan360, _tspan361, _tspan362, _tspan363, _tspan364, _tspan365, _tspan366, _tspan367;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtnAscii2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rtn-ascii-2",
    className: "rtn-ascii-2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 950",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-5.93 300.78)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593\u2593\u2592\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2592\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(120.57 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.51 348.36)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.51 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(95.95 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593\u2593\u2593\u2593\u2593\u2593\u2593\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(71.25 515.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593\u2593\u2593\u2593\u2593\u2593\u2593\u2593\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(71.25 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(335.01 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2592\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 158.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591                      \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 16.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "                                \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 39.84)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591                 \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591                       \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 63.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 87.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591        \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 111.47)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591       \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591       \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 135.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 183.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 206.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591      \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 230.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 254.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-.33 278.11)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-5.93 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(458.01 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(540.41 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2592\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(983.46 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1295.13 323.98)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(487.73 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2593\u2592\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2593\u2591\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1153.07 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(971.31 348.27)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1129.44 348.27)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2593\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2592\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(525.84 348.36)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(925.92 348.36)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2593\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-6.96 348.36)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-17.55 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-29.04 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "  \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-29.04 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "  \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-39.52 444.22)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "   \u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-41.37 468.06)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "   \u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-48.56 492.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "    \u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-41.37 515.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "   \u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-63.16 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "     \u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-65.42 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "     \u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-76.31 587.66)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "      \u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-77.54 611.09)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "      \u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-88.23 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "       \u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-89.87 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "       \u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-100.76 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "        \u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-100.76 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "        \u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-112.68 731.1)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "         \u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-114.12 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "         \u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(94.74 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(359.84 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(492.9 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(656.68 420.18)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(959.38 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1165.09 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1283.46 372.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1404.7 372.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1283.46 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1404.7 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(527.22 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(924.65 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(971.31 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1141.87 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(94.74 444.22)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(217.57 444.22)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(368.9 443.79)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(359.84 467.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(492.9 443.79)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(492.9 467.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83.42 468.06)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(205.91 468.06)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(71.25 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(456.92 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(60.06 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(57.28 587.66)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.22 611.09)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.22 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(35.46 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(35.46 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(23.47 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(23.47 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(11.06 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(11.06 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(133.24 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(422.08 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(360.7 611.09)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(169.06 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(238.95 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(360.7 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(157.49 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan90 || (_tspan90 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(157.93 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan91 || (_tspan91 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(239.54 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan92 || (_tspan92 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(146.06 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan93 || (_tspan93 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(145.33 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan94 || (_tspan94 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(249.79 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan95 || (_tspan95 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(251.55 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan96 || (_tspan96 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(134.2 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan97 || (_tspan97 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(261.22 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan98 || (_tspan98 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(262.98 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan99 || (_tspan99 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(274.7 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan100 || (_tspan100 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(373.15 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan101 || (_tspan101 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(373.15 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan102 || (_tspan102 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(385.02 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan103 || (_tspan103 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(396.89 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan104 || (_tspan104 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(396.89 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan105 || (_tspan105 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(646.81 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan106 || (_tspan106 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(769.92 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan107 || (_tspan107 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(635.16 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan108 || (_tspan108 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(645.9 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan109 || (_tspan109 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(635.16 515.81)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan110 || (_tspan110 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(622.92 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan111 || (_tspan111 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(622.92 562.74)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan112 || (_tspan112 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(611.6 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan113 || (_tspan113 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(611.6 610.95)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan114 || (_tspan114 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(599.73 634.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan115 || (_tspan115 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(599.73 659.16)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan116 || (_tspan116 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(587.31 682.35)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan117 || (_tspan117 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(587.31 707)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan118 || (_tspan118 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(575.81 730.01)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan119 || (_tspan119 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(575.81 755.02)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan120 || (_tspan120 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(563.57 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan121 || (_tspan121 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(769.92 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan122 || (_tspan122 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(757.87 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan123 || (_tspan123 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(757.87 515.81)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan124 || (_tspan124 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(746 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan125 || (_tspan125 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(746 562.74)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan126 || (_tspan126 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(733.95 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan127 || (_tspan127 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(733.03 610.95)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan128 || (_tspan128 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(721.53 634.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan129 || (_tspan129 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(721.53 659.15)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan130 || (_tspan130 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(708.75 682.35)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan131 || (_tspan131 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(709.66 707)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan132 || (_tspan132 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(697.97 730.01)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan133 || (_tspan133 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(697.24 755.02)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan134 || (_tspan134 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(686.29 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan135 || (_tspan135 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1270.51 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan136 || (_tspan136 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1270.51 443.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan137 || (_tspan137 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(959.38 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan138 || (_tspan138 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(947.34 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan139 || (_tspan139 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(945.96 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan140 || (_tspan140 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(935.5 515.86)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan141 || (_tspan141 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(935.5 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan142 || (_tspan142 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(923.49 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan143 || (_tspan143 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(922.45 587.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan144 || (_tspan144 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(911.09 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan145 || (_tspan145 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(908.76 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan146 || (_tspan146 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(899.2 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan147 || (_tspan147 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(899.2 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan148 || (_tspan148 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(887.32 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan149 || (_tspan149 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(887.32 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan150 || (_tspan150 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(875.05 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan151 || (_tspan151 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(875.05 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan152 || (_tspan152 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1259.75 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan153 || (_tspan153 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1257.82 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan154 || (_tspan154 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1257.82 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan155 || (_tspan155 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1246.48 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan156 || (_tspan156 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1088.92 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan157 || (_tspan157 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1079.57 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan158 || (_tspan158 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1092.04 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan159 || (_tspan159 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1058.03 515.86)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan160 || (_tspan160 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1045.85 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan161 || (_tspan161 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1045.85 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan162 || (_tspan162 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1032.81 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan163 || (_tspan163 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1020.63 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan164 || (_tspan164 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1010.42 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan165 || (_tspan165 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1009.01 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan166 || (_tspan166 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1103.37 587.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan167 || (_tspan167 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1114.71 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan168 || (_tspan168 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1126.61 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan169 || (_tspan169 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1126.61 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan170 || (_tspan170 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1139.36 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan171 || (_tspan171 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(996.82 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan172 || (_tspan172 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1151.27 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan173 || (_tspan173 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(996.82 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan174 || (_tspan174 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(996.82 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan175 || (_tspan175 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1174.5 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan176 || (_tspan176 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1163.45 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan177 || (_tspan177 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1163.45 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan178 || (_tspan178 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1246.48 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan179 || (_tspan179 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1345.38 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan180 || (_tspan180 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1345.38 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan181 || (_tspan181 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1333.48 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan182 || (_tspan182 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1333.48 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan183 || (_tspan183 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1322.43 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan184 || (_tspan184 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1321.3 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan185 || (_tspan185 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1309.96 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan186 || (_tspan186 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1309.96 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan187 || (_tspan187 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1369.19 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan188 || (_tspan188 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1369.19 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan189 || (_tspan189 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1381.37 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan190 || (_tspan190 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1381.37 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan191 || (_tspan191 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1393.84 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan192 || (_tspan192 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1393.84 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan193 || (_tspan193 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2588"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 803.64)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan194 || (_tspan194 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 827.24)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan195 || (_tspan195 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 850.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan196 || (_tspan196 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591              \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591                \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 874.55)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan197 || (_tspan197 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 898.24)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan198 || (_tspan198 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "     \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 922.24)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan199 || (_tspan199 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591 "))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 945.24)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan200 || (_tspan200 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591    \u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591   \u2591\u2591 "))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(146.06 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan201 || (_tspan201 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(156.45 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan202 || (_tspan202 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(159.29 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan203 || (_tspan203 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(180.54 658.71)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan204 || (_tspan204 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(167.86 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan205 || (_tspan205 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(169.06 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan206 || (_tspan206 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(180.54 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan207 || (_tspan207 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(421.61 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan208 || (_tspan208 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(407.66 755.02)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan209 || (_tspan209 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(407.66 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan210 || (_tspan210 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(396.89 707)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan211 || (_tspan211 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(398.77 682.35)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan212 || (_tspan212 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(383.75 659.16)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan213 || (_tspan213 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(383.75 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan214 || (_tspan214 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(383.75 611.09)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan215 || (_tspan215 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(422.08 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan216 || (_tspan216 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(456.92 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan217 || (_tspan217 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(479.34 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan218 || (_tspan218 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(514.24 515.81)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan219 || (_tspan219 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(504.4 467.96)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan220 || (_tspan220 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(504.4 443.79)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan221 || (_tspan221 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(497.43 420.18)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan222 || (_tspan222 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(514.24 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan223 || (_tspan223 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(797.65 420.18)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan224 || (_tspan224 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(935.5 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan225 || (_tspan225 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1165.09 372.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan226 || (_tspan226 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1165.09 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan227 || (_tspan227 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1177.65 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan228 || (_tspan228 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1188.43 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan229 || (_tspan229 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1188.43 467.96)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan230 || (_tspan230 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1200.48 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan231 || (_tspan231 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1211.9 515.86)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan232 || (_tspan232 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1224.59 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan233 || (_tspan233 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1224.59 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan234 || (_tspan234 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(240.72 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan235 || (_tspan235 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(227.86 444.22)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan236 || (_tspan236 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(228.93 468.06)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan237 || (_tspan237 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(792.42 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan238 || (_tspan238 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(783.07 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan239 || (_tspan239 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(783.07 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan240 || (_tspan240 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(767.95 515.81)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan241 || (_tspan241 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(767.95 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan242 || (_tspan242 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(755.67 562.74)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan243 || (_tspan243 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(755.67 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan244 || (_tspan244 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(743.54 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan245 || (_tspan245 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(745.11 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan246 || (_tspan246 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(733.03 659.15)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan247 || (_tspan247 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(733.04 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan248 || (_tspan248 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(720 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan249 || (_tspan249 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(721.53 730.01)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan250 || (_tspan250 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(708.75 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan251 || (_tspan251 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(708.75 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan252 || (_tspan252 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1068.9 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan253 || (_tspan253 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1055.93 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan254 || (_tspan254 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1044.5 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan255 || (_tspan255 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1055.93 587.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan256 || (_tspan256 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1044.5 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan257 || (_tspan257 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1031.22 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan258 || (_tspan258 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1031.22 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan259 || (_tspan259 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1019.17 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan260 || (_tspan260 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1019.17 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan261 || (_tspan261 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1019.17 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan262 || (_tspan262 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1007.43 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan263 || (_tspan263 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1428.37 372.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan264 || (_tspan264 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1414.78 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan265 || (_tspan265 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1416.02 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan266 || (_tspan266 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1403.45 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan267 || (_tspan267 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1403.45 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan268 || (_tspan268 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1392.54 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan269 || (_tspan269 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1392.54 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan270 || (_tspan270 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1380.39 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan271 || (_tspan271 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1380.39 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan272 || (_tspan272 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1366.59 587.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan273 || (_tspan273 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1367.62 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan274 || (_tspan274 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1355.47 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan275 || (_tspan275 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1355.47 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan276 || (_tspan276 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1343.73 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan277 || (_tspan277 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1343.73 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan278 || (_tspan278 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1331.79 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan279 || (_tspan279 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1331.79 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan280 || (_tspan280 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1320.05 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan281 || (_tspan281 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1414.78 372.69)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan282 || (_tspan282 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1270.51 395.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan283 || (_tspan283 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1153.07 372.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan284 || (_tspan284 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1257.82 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan285 || (_tspan285 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1404.7 420.39)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan286 || (_tspan286 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1392.54 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan287 || (_tspan287 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1248.12 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan288 || (_tspan288 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1380.39 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan289 || (_tspan289 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1367.62 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan290 || (_tspan290 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1355.47 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan291 || (_tspan291 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1208.64 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan292 || (_tspan292 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1340.53 659.6)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan293 || (_tspan293 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1103.37 611.17)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan294 || (_tspan294 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1052.95 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan295 || (_tspan295 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1066.25 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan296 || (_tspan296 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1005.77 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan297 || (_tspan297 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1163.45 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan298 || (_tspan298 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1320.05 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan299 || (_tspan299 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1331.79 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan300 || (_tspan300 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1140.28 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan301 || (_tspan301 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(777.32 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan302 || (_tspan302 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(767.28 492.04)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan303 || (_tspan303 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(755.67 540.28)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan304 || (_tspan304 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(743.54 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan305 || (_tspan305 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(732.12 634.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan306 || (_tspan306 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(912.93 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan307 || (_tspan307 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(720 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan308 || (_tspan308 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(710.89 730.01)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan309 || (_tspan309 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(697.24 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan310 || (_tspan310 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(875.05 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan311 || (_tspan311 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(887.32 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan312 || (_tspan312 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(393.41 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan313 || (_tspan313 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(383.75 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan314 || (_tspan314 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(370.69 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan315 || (_tspan315 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(370.69 611.09)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan316 || (_tspan316 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(444.09 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan317 || (_tspan317 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(410.09 587.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan318 || (_tspan318 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(467.8 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan319 || (_tspan319 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(216.79 468.06)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan320 || (_tspan320 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(228.93 419.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan321 || (_tspan321 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(141.94 754.53)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan322 || (_tspan322 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(156.45 706.59)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan323 || (_tspan323 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(166.38 658.77)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan324 || (_tspan324 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(228.43 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan325 || (_tspan325 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(153.22 703.43)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan326 || (_tspan326 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2592"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(85 444.22)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan327 || (_tspan327 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(60.06 540.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan328 || (_tspan328 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(48.46 587.66)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan329 || (_tspan329 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.87 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan330 || (_tspan330 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.53 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan331 || (_tspan331 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(13.19 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan332 || (_tspan332 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan333 || (_tspan333 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(239.54 682.4)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan334 || (_tspan334 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(251.55 730.12)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan335 || (_tspan335 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(262.98 778.91)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan336 || (_tspan336 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(409.26 778.76)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan337 || (_tspan337 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(396.89 587.66)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan338 || (_tspan338 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(431.43 562.8)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan339 || (_tspan339 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(359.84 443.79)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan340 || (_tspan340 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(646.81 420.18)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan341 || (_tspan341 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(635.16 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan342 || (_tspan342 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(623.8 515.81)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan343 || (_tspan343 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(611.6 562.74)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan344 || (_tspan344 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(599.73 610.95)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan345 || (_tspan345 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(587.31 659.16)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan346 || (_tspan346 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(575.81 706.87)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan347 || (_tspan347 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(564.39 754.92)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan348 || (_tspan348 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(947.34 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan349 || (_tspan349 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(935.5 491.83)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan350 || (_tspan350 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(923.49 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan351 || (_tspan351 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(899.21 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan352 || (_tspan352 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(863.72 779.46)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan353 || (_tspan353 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1009.01 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan354 || (_tspan354 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1020.63 682.72)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan355 || (_tspan355 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1032.81 634.93)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan356 || (_tspan356 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1044.5 587.41)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan357 || (_tspan357 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1115.87 634.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan358 || (_tspan358 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1152.49 730.25)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan359 || (_tspan359 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1165.09 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan360 || (_tspan360 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1177.65 443.68)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan361 || (_tspan361 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1177.65 467.97)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan362 || (_tspan362 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1079.57 539.75)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan363 || (_tspan363 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1200.48 515.86)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan364 || (_tspan364 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1248.12 515.94)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan365 || (_tspan365 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1213.82 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan366 || (_tspan366 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1235.94 563.38)",
    fill: "currentColor",
    style: {
      fontFamily: "Menlo-Regular, Menlo",
      fontSize: 21
    }
  }, _tspan367 || (_tspan367 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2593"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtnAscii2);
export default __webpack_public_path__ + "static/media/rtn-ascii-2.8c65f29b9bd1011088b31b73800fab64.svg";
export { ForwardRef as ReactComponent };